<template>
    <base-panel
        :panel="panel"
        v-on:continue="handleContinue()"
        v-on:edit-action="handleEditAction($event)"
        v-on:update-width="handleUpdateWidth($event)"
        ref="basePanel"
    >
        <template slot="content">
            <textarea
                :id="'text-area-' + panelID"
                @input="saveNotes()"
                v-model="learnerNotes"
                maxlength="5000"
                :placeholder="panel.textarea_placeholder || 'Enter your notes here...'"
                class="form-control textarea"
                :rows="panel.textarea_rows || 10"
                :disabled="locked"
                aria-label="Learner notepad input"
            ></textarea>
            <div
                class="tiny d-flex justify-content-end align-items-center position-relative height-0 mr-1"
                style="top: 8px; height: 15px;"
            >
                <div class="d-flex align-items-center position-relative">
                    <div v-show="notesSaving">
                        <div class="d-flex align-items-center">
                            <div class="spinner-border spinner-border-tiny text-primary ml-1 mr-2" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <div class="text-secondary font-weight-500">{{ labelsTranslated.notesSaving }}...</div>
                        </div>
                    </div>
                    <div v-show="!notesSaving">
                        <span class="icon icon-glyphicons-basic-circle-check ml-1 mr-1 text-success"></span>
                        <span class="text-secondary font-weight-500">{{ labelsTranslated.notesSaved }}</span>
                    </div>
                </div>
            </div>
        </template>
    </base-panel>
</template>

<script>
import http from "@/axios.js"
import debounce from "lodash.debounce"
import BasePanel from "@/components/panels/BasePanel"

export default {
    name: "NotepadPanel",
    components: {
        BasePanel,
    },
    props: {
        panel: {
            type: Object,
            required: true,
        },
        locked: {
            type: Boolean,
            required: false,
        },
        sessionId: {
            type: [String, Number],
            required: true,
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            learnerNotes: this.$store.getters.sessionNotes,
            notesSaving: false,
        }
    },
    watch: {
        storedNotes: function (newValue) {
            this.learnerNotes = newValue
        },
    },
    computed: {
        panelID() {
            return this.panel.id
        },
        storedNotes() {
            return this.$store.getters.sessionNotes
        },
        labelsTranslated() {
            return this.$store.getters.sessionLabelsTranslated
        },
    },
    methods: {
        saveNotes() {
            this.notesSaving = true
            this.$store.commit("setSessionNotes", this.learnerNotes)
            this.saveNotesDebounced()
        },
        // Save the notes (debounced, because this is triggered on input to the notepad).
        saveNotesDebounced: debounce(async function () {
            await this.saveUpdatedNotes()
            this.notesSaving = false
        }, 400),
        saveUpdatedNotes() {
            http.post(`/api/students/sessions/${this.sessionId}/notes/`, {
                notes_content: this.learnerNotes,
            })
        },
        handleContinue() {
            this.$emit("continue")
        },
        handleEditAction(action) {
            this.$emit("edit-action", action)
        },
        handleUpdateWidth($event) {
            this.$emit("update-width", $event)
        },
        skipVideos() {
            this.$refs.basePanel.skipVideos()
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.textarea {
    flex: 1 1 auto;
    background-color: #fefeff;
}
</style>